export default "__VITE_ASSET__BQ9z_o4D__"